"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../../foundations/typography/Text/Text.js");
const components_action_IconButton_IconButton = require("../../../action/IconButton/IconButton.js");
require("../../../action/Button/Button.js");
require("../../../action/Badge/BadgeButton.js");
require("../../../action/Badge/BadgeRadio.js");
require("../../../action/Badge/BadgeCheckbox.js");
const components_overlay_Modal_components_hooks_useModalContext = require("./hooks/useModalContext.js");
const Modal_module = require("../../../../chunks/Modal.module-DOd1Y64p.js");
const ModalHeader = ({
  closeButtonDescription,
  children,
  headingLevel = "h1",
  className,
  ...props
}) => {
  const { isDismissable, onClose } = components_overlay_Modal_components_hooks_useModalContext.useModalContext();
  return /* @__PURE__ */ jsxRuntime.jsxs("header", { className: clsx.clsx(Modal_module.styles.modalHeader, className), ...props, children: [
    typeof children === "string" ? /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.Text, { component: headingLevel, variant: "heading-small", children }) : children,
    isDismissable && /* @__PURE__ */ jsxRuntime.jsx(components_action_IconButton_IconButton.IconButton, { variant: "ghost", onPress: onClose, "aria-label": closeButtonDescription })
  ] });
};
exports.ModalHeader = ModalHeader;
